const Shopping = () => ({
  component: import("@/pages/shop/Shopping"),
});
export default ({ authGuard, guestGuard }) => [
  {
    path: "/",
    name: "welcome",
    component: require("~/pages/Home.vue").default,
  },
  {
    path: "/support",
    meta: { breadcrumb: false, public: false },
    name: "support",
    component: require(`@/pages/support/Support.vue`).default,
  },
  // Authenticated routes.
  ...authGuard([
    {
      // TODO supersimulado chumbado
      path: "/simulados/cfp-50",
      // redirect: '/'
      meta: { breadcrumb: false, public: false },
      name: "event.mocks",
      component: require(`@/pages/event_mock/EventMock.vue`).default,
    },
    {
      path: "/request/extending",
      meta: { breadcrumb: false, public: false },
      name: "extending",
      component: require(
        /* webpackChunkName: "requests" */
        /* webpackMode: "lazy-once" */
        `@/pages/requests/Extending.vue`,
      ).default,
    },
    {
      path: "/courses",
      meta: { breadcrumb: false, public: false },
      name: "courses",
      component: require(
        /* webpackChunkName: "courses" */
        /* webpackMode: "lazy-once" */
        `@/pages/course/CourseList.vue`,
      ).default,
    },
    {
      path: "/dashboard",
      meta: { breadcrumb: false, public: false },
      name: "dashboard",
      component: require(
        /* webpackChunkName: "dashboard" */
        /* webpackMode: "lazy" */
        `@/pages/dashboard/Dash.vue`,
      ).default,
    },
    {
      path: "/courses/:courseId/classroom/:sectionItemId/:slug?",
      meta: { breadcrumb: false, public: false },
      name: "classroom",
      component: require(
        /* webpackChunkName: "classroom" */
        /* webpackMode: "lazy-once" */
        `@/pages/class/ClassRoom.vue`,
      ).default,
    },
    {
      path: "/courses/:courseId/:slug?",
      meta: { public: false },
      name: "course",
      component: require(`@/pages/course/Course.vue`).default,
    },
    {
      path: "/courses/:courseId/:slug/student-area",
      meta: { public: false },
      name: "student-area",
      component: require(`@/pages/course/StudentArea.vue`).default,
    },
    {
      path: "/contract-agreement/:enrollmentId/:courseId",
      meta: { public: false },
      name: "contract.agreement",
      component: require(`@/pages/contract/ContractAgreement.vue`).default,
    },
    // { path: '/home', name: 'home', component: require('~/pages/Home.vue') },
    {
      path: "/user/profile",
      meta: { breadcrumb: false }, // breadcrumb: false,
      name: "profile",
      component: require(
        /* webpackChunkName: "profile" */
        /* webpackMode: "lazy-once" */
        `@/pages/profile/Profile.vue`,
      ).default,
    },
    {
      path: "/settings",
      component: require("~/pages/settings/index.vue").default,
      children: [
        { path: "", redirect: { name: "settings.profile" } },
        {
          path: "profile",
          name: "settings.profile",
          component: require("~/pages/settings/profile.vue").default,
        },
        {
          path: "password",
          name: "settings.password",
          component: require("~/pages/settings/password.vue").default,
        },
      ],
    },
    {
      path: "/session-alert",
      meta: { breadcrumb: false, public: true },
      name: "sessionAlert",
      component: require(
        /* webpackChunkName: "alert" */
        /* webpackMode: "lazy-once" */
        `@/pages/alert/Alert.vue`,
      ).default,
    },
    {
      path: "/my-exams",
      meta: { breadcrumb: false, public: false },
      name: "exams",
      component: require(
        /* webpackChunkName: "exams" */
        /* webpackMode: "lazy-once" */
        `@/pages/exams/ExamList.vue`,
      ).default,
    },
  ]),

  // Guest routes.
  ...guestGuard([
    {
      path: "/shopping",
      meta: { breadcrumb: false, public: false },
      name: "shop",
      component: require(
        /* webpackChunkName: "shopping" */
        /* webpackMode: "lazy-once" */
        `@/pages/shop/Shopping.vue`,
      ).default,
    },
    {
      path: "/search",
      meta: { breadcrumb: false, public: false },
      name: "mocks.search",
      component: require(
        /* webpackChunkName: "search" */
        /* webpackMode: "lazy-once" */
        `@/pages/quiz/MockSearch.vue`,
      ).default,
    },
    {
      path: "/mocks/:id",
      meta: { breadcrumb: false, public: false },
      name: "mocks.start",
      component: require(
        /* webpackChunkName: "question-list" */
        /* webpackMode: "lazy-once" */
        `@/pages/quiz/QuestionList.vue`,
      ).default,
    },
    {
      path: "/mocks",
      meta: { breadcrumb: false, public: false },
      name: "mocks",
      component: require(
        /* webpackChunkName: "mocks" */
        /* webpackMode: "lazy-once" */
        `@/pages/quiz/MockList.vue`,
      ).default,
    },
    {
      path: "/mocks-logs",
      meta: { breadcrumb: false, public: false },
      name: "mocks.logs",
      component: require(
        /* webpackChunkName: "mocks-logs" */
        /* webpackMode: "lazy-once" */
        `@/pages/mock/MockLogs.vue`,
      ).default,
    },
    {
      // TODO supersimulado chumbado
      path: "/resultado/cfp-50/:user/:result",
      // redirect: '/'
      meta: { breadcrumb: false, public: false },
      name: "event.mocks.result",
      component: require(`@/pages/event_mock/EventResult.vue`).default,
    },
    {
      // TODO supersimulado chumbado
      path: "/simulados/cfp-50/finalizado",
      // redirect: '/'
      meta: { breadcrumb: false, public: false },
      name: "event.mocks.finish",
      component: require(`@/pages/event_mock/EventEnd.vue`).default,
    },
    {
      // TODO supersimulado chumbado
      path: "/simulados/cfp-50/:id",
      // redirect: '/'
      meta: { breadcrumb: false, public: false },
      name: "event.mocks.start",
      component: require(`@/pages/event_mock/EventQuestionList.vue`).default,
    },
    // {
    //   path: '/order/:orderId/checkout/',
    //   meta: { breadcrumb: false, public: true },
    //   name: 'checkout',
    //   component: require(
    //     /* webpackChunkName: "checkout" */
    //     /* webpackMode: "lazy-once" */
    //     `@/pages/shop/Checkout.vue`
    //   ).default
    // },
    {
      path: "/order/:orderId/checkout-v2/",
      meta: { breadcrumb: false, public: true },
      name: "checkout-v2",
      component: require(
        /* webpackChunkName: "checkout" */
        /* webpackMode: "lazy-once" */
        `@/pages/shop/pagarme/Checkout.vue`,
      ).default,
    },
    {
      path: "/order/:orderId/checkout/",
      meta: { breadcrumb: false, public: true },
      name: "checkout",
      component: require(
        /* webpackChunkName: "checkout" */
        /* webpackMode: "lazy-once" */
        `@/pages/shop/pagarme/Checkout.vue`,
      ).default,
    },
    {
      path: "/order/:orderId/checkout2/",
      meta: { breadcrumb: false, public: true },
      name: "checkout2",
      component: require(
        /* webpackChunkName: "checkout" */
        /* webpackMode: "lazy-once" */
        `@/pages/shop/MPCheckout.vue`,
      ).default,
    },
    {
      path: "/thankyou/:gatewayIdentifier",
      meta: { public: false },
      name: "thankyou",
      component:
        /* webpackChunkName: "checkout" */
        /* webpackMode: "lazy-once" */
        require(`@/pages/shop/Thankyou.vue`).default,
    },
    // { path: '/login', name: 'login', component: require('~/pages/auth/login.vue') },
    {
      path: "/register",
      name: "register",
      meta: { breadcrumb: false, public: true },
      component: require("~/pages/auth/Register.vue").default,
    },
    // { path: '/password/forgot', name: 'password.request', component: require('~/pages/auth/password/email.vue') },
    {
      path: "/password/forgot",
      meta: { breadcrumb: false, public: true },
      name: "password.request",
      component: require("@/pages/auth/ForgotPassword.vue").default,
    },
    {
      path: "/password/reset/:token/email/:email",
      meta: { breadcrumb: false, public: true },
      name: "password.reset",
      component: require("~/pages/auth/ResetPassword.vue").default,
    },
    {
      path: "/403",
      meta: { breadcrumb: false, public: true },
      name: "AccessDenied",
      component: require(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/pages/errors/403.vue`,
      ).default,
    },
    {
      path: "/500",
      meta: {
        public: true,
      },
      name: "ServerError",
      component: require(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/pages/errors/500.vue`,
      ).default,
    },
    {
      path: "/login",
      meta: {
        public: true,
      },
      name: "login",
      component: require(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/pages/auth/Login.vue`,
      ).default,
    },
  ]),
  {
    path: "*",
    meta: { breadcrumb: false, public: true },
    component: require("~/pages/errors/404.vue").default,
  },
];
